<template>
  <div>
    <p class="goldenP">
      <img
        src="@/assets/orStar.png"
        style="width: 14px; margin-top: -4px; margin-left: 10px"
        alt=""
      />
      {{ text }}
    </p>
  </div>
</template>

<script>
export default {
  name: "GoldenButton",
  props: {
    text: String,
  },
};
</script>

<style scoped>
.goldenP {
  background: #2c2d31;
  height: 45px;
  color: #f0af49;
  font-weight: bold;
  padding-top: 5%;
  font-size: 14px;
  padding: 10px;
  margin-bottom: 0px;
}
</style>
